import { graphql } from "gql";

const ADMIN_EDIT_USER_MUTATION = graphql(`
  mutation AdminEditUser($id: ID!, $input: AdminEditUserInput!) {
    adminEditUser(id: $id, input: $input) {
      ...User
    }
  }
`);

export default ADMIN_EDIT_USER_MUTATION;
